module.exports = __webpack_public_path__ + "img/STU PT headers login@2x.9eca0924.png";